"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _definitions = require('../definitions');
var _mergeClassName = require('../../utils/mergeClassName'); var _mergeClassName2 = _interopRequireDefault(_mergeClassName);

const settingsSchema = {
  type: "object",
  fields: [
    { id: "step", type: "number", default: 1 },
    { id: "placeholder", type: "string" }
  ]
} ;

const component = {
  mixins: [_definitions.vueComponentMixin],
  computed: {
    unsafeValue: {
      get() {
        return this.$props.value;
      },
      set(val) {
        // 需要处理整数字段 和 NaN
        if (typeof val !== "number" || Number.isNaN(val)) val = 0;
        if (this.schema.type === "integer") val = Math.round(val);
        this.editValue = val
      }
    },
    finalClassName() {
      const props = this.$props;
      const settings = props.uiSettings;
      return _mergeClassName2.default.call(void 0, "ds-inputbox", props.ui.className, props.className);
    }
  }
};

exports. default = component;
 const numberInputModule = {
  id: "numberInput",
  settingsSchema,
  component
}; exports.numberInputModule = numberInputModule;

;(function(options){
  var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model.number.lazy",
        value: _vm.unsafeValue,
        expression: "unsafeValue",
        modifiers: { number: true, lazy: true }
      }
    ],
    class: _vm.finalClassName,
    style: _vm.ui.style,
    attrs: {
      id: _vm.inputId,
      type: "number",
      readonly: _vm.readonly,
      placeholder: _vm.settings.placeholder,
      step: _vm.settings.step,
      max: _vm.schema.validation && _vm.schema.validation.maximum,
      min: _vm.schema.validation && _vm.schema.validation.minimum
    },
    domProps: { value: _vm.unsafeValue },
    on: {
      change: function($event) {
        _vm.unsafeValue = _vm._n($event.target.value)
      },
      blur: function($event) {
        return _vm.$forceUpdate()
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true


  options.render = render
  options.staticRenderFns = staticRenderFns
  options._compiled = true
})(exports.default);
